export default __webpack_public_path__ + "static/media/Accounts_Icon.f3cc5899.png";